import { PostType } from '@tribeplatform/gql-client/types'

import { PostComposerButton } from './@types/index.js'

interface CanCreateAnyPostProps {
  buttons?: PostComposerButton[]
  postTypes?: PostType[]
}

export const canCreateAnyPost = ({
  buttons = [],
  postTypes = [],
}: CanCreateAnyPostProps) => {
  const hasPermission = ({
    spaceId,
    postTypeId,
  }: {
    spaceId?: string
    postTypeId?: string
  }) => {
    if (!spaceId && !postTypeId) {
      return true
    }

    if (!spaceId) {
      return !!postTypes?.find(
        postType =>
          postType.id === postTypeId &&
          postType.authMemberProps?.availableSpaces?.length > 0,
      )
    }

    const canPostToAnySpace = !!postTypes?.find(postType =>
      postType.authMemberProps?.availableSpaces?.some(
        space => space?.id === spaceId,
      ),
    )

    return canPostToAnySpace
  }

  if (!buttons?.length) {
    return true
  }

  return buttons.some(button =>
    hasPermission({ spaceId: button?.spaceId, postTypeId: button?.postTypeId }),
  )
}
